<template lang="pug">
  v-row.mx-auto
    v-col(
      v-if="title"
      :cols="12")
      v-card.text-center(flat)
        v-card-title.justify-center.text-break.px-6.mx-8 {{ title }}
    v-col(
      :cols="12"
      style="width: 100%")
      component.px-8(
        :style="height ? `height: ${height}px` : undefined"
        :is="illustration")
    v-col.shrink.mx-auto(
      v-if="body || $slots.actions"
      :cols="12")
      v-card.text-center(flat)
        v-card-text.px-8(
          v-if="body"
          v-html="body")
        v-card-actions.justify-center(v-if="$slots.actions")
          slot(name="actions")
</template>

<script>
export default {
  props: {
    title: String,
    body: String,
    illustration: Object,
    height: {
      type: Number,
      default: 100
    }
  }
}
</script>
